import React, { useEffect, useState, useContext } from 'react';
import Template from './template';
import { MoveCleaningServiceInfo } from 'components';
import { apiGetServiceInfo } from 'api/ZimssaAPI';
import { useApiRequest } from 'hooks';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import { getCarrierYear, getBirthdayWithDot } from 'commons/ZimssaHelper';
import { PAGE_SERVICE_MOVECLEANING } from 'commons/ZimssaString';
import { CERT_INFO } from 'router/PageUrl';

function MoveCleaningServiceInfoView(): React.ReactElement {
  const { service } = useContext(PartnerAuthState);
  const serviceIdx = service.find(
    (item) => item.serviceType === 'move_cleaning'
  )?.serviceIdx;
  const [serviceInfo, setServiceInfo] =
    useState<IMoveCleaningInfoState>(defaultState);
  const [fetchResult, fetchServiceInfo] =
    useApiRequest<any>(apiGetServiceInfo);

  useEffect(() => {
    if (serviceIdx) {
      fetchServiceInfo({
        type: 'REQUEST',
        body: ['move_cleaning', serviceIdx],
      });
    }
  }, [serviceIdx, fetchServiceInfo]);

  useEffect(() => {
    const { result, data } = fetchResult;
    if (result === 'success') {
      setServiceInfo({
        serviceName: data.service.serviceName,
        serviceImage: data.service.serviceImage,
        profile: {
          value: data.user.profileImage,
          name: data.user.name,
          phone: data.user.phone,
        },
        birthday: getBirthdayWithDot(data.user.birthday),
        carrierYear: data.serviceUser.carrierYear,
        email: data.user.email,
        location: `${data.service.location1} ${data.service.location2}`,
        introduce: data.service.introduce,
        businessRegistration: `${data.service.businessRegistrationOwner} / ${data.service.businessRegistrationNumber} / ${data.service.taxClassification}`,
      });
    }
  }, [fetchResult]);

  const moveCleaningServiceInfoProps = {
    serviceName: serviceInfo.serviceName,
    serviceImage: serviceInfo.serviceImage,
    profile: serviceInfo.profile,
    birthday: serviceInfo.birthday,
    carrierYear: getCarrierYear(Number(serviceInfo.carrierYear)),
    email: serviceInfo.email,
    location: serviceInfo.location,
    introduce: serviceInfo.introduce,
    businessRegistration: {
      contents: serviceInfo.businessRegistration,
      href: `${CERT_INFO.url}/businessregistration/move_cleaning/${serviceIdx}`,
    },
  };
  return (
    <Template title={PAGE_SERVICE_MOVECLEANING}  serviceType={'movecleaning'} serviceIdx={serviceIdx ? serviceIdx : 0}>
      <MoveCleaningServiceInfo {...moveCleaningServiceInfoProps} />
    </Template>
  );
}

export default MoveCleaningServiceInfoView;

interface IMoveCleaningInfoState {
  profile: {
    value: string;
    name: string;
    phone: string;
  };
  serviceName: string;
  serviceImage: string;
  birthday: string;
  carrierYear: string;
  email: string;
  location: string;
  introduce: string;
  businessRegistration: string;
}

const defaultState: IMoveCleaningInfoState = {
  profile: {
    value: '',
    name: '',
    phone: '',
  },
  serviceName: '',
  serviceImage: '',
  birthday: '',
  carrierYear: '',
  email: '',
  location: '',
  introduce: '',
  businessRegistration: '',
};
